import { render, staticRenderFns } from "./CalendarDateTitle.vue?vue&type=template&id=2ba8c5fa&scoped=true&"
import script from "./CalendarDateTitle.vue?vue&type=script&lang=js&"
export * from "./CalendarDateTitle.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDateTitle.vue?vue&type=style&index=0&id=2ba8c5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8c5fa",
  null
  
)

export default component.exports